/* @flow weak */
import { combineReducers } from 'redux'
import app from './app/reducer'
import config from './config/reducer'
import users from './users/reducer'
import lessons from './lessons/reducer'
import tags from './tags/reducer'
import tests from './tests/reducer'
import homeworks from './homeworks/reducer'
import localizations from './localizations/reducer'
import loader from './loader/reducer'
import groups from './groups/reducer'
import intl from './intl/reducer'
import notifications from './notifications/reducer'
import results from './results/reducer'
import subjects from './subjects/reducer'
import { fieldsReducer as fields } from './lib/redux-fields'
import { listsReducer as lists } from './lib/redux-lists'
import { updateStateOnStorageLoad } from './configureStorage'

const resetStateOnSignOut = (reducer, initialState) => (state, action) => {
  // Reset app state on sign out, stackoverflow.com/q/35622588/233902.
  // const userWasSignedOut =
  //   action.type === (state.users && state.users.viewer) && !action.payload.user
  const userWasSignedOut =
    action.type === 'SIGN_OUT'

  if (userWasSignedOut) {
    // Preserve state without sensitive data.
    state = {
      app: state.app,
      intl: state.intl,
      config: initialState.config,
      users: state.users,
      // device: initialState.device,
    }
  }
  return reducer(state, action)
}

const configureReducer = (initialState: Object) => {
  let reducer = combineReducers({
    app,
    config,
    fields,
    users,
    intl,
    lessons,
    lists,
    tags,
    tests,
    homeworks,
    groups,
    loader,
    notifications,
    localizations,
    results,
    subjects,
  })

  // The power of higher-order reducers, http://slides.com/omnidan/hor
  reducer = resetStateOnSignOut(reducer, initialState)
  reducer = updateStateOnStorageLoad(reducer)

  return reducer
}

export default configureReducer



// WEBPACK FOOTER //
// ./src/common/configureReducer.js